export const logout = (history) => {
    history.push("/login");
}
